import { Observable } from 'rxjs';
import { catchError, take } from 'rxjs/operators';

import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { ApiResponse } from '@shared/models';
import { Billing, Cfdi, Regime } from '@shared/models/billing.model';

import { BillingService } from '../billing-info/services/billing.service';

@Component({
  selector: 'app-profile-bills-add',
  templateUrl: './profile-bills-add.page.html',
  styleUrls: ['./profile-bills-add.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileBillsAddPage implements OnInit {
  load = false;

  @Input() billing: Billing | null = null;

  form: UntypedFormGroup = new UntypedFormGroup({
    id: new UntypedFormControl(''),
    taxpayer: new UntypedFormControl('', [Validators.required]),
    rfc: new UntypedFormControl('', [
      Validators.required,
      Validators.minLength(12),
      Validators.maxLength(13),
      Validators.pattern(/^[A-ZÑ&]{3,4}\d{6}[A-V1-9][A-Z1-9][0-9A]$/),
    ]),
    name: new UntypedFormControl('', [Validators.required]),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    tax_regime: new UntypedFormControl('', [Validators.required]),
    use_cfdi: new UntypedFormControl('', [Validators.required]),
    zip_code: new UntypedFormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]),
  });

  errorData = {
    name: false,
    email: false,
    rfc: false,
    taxpayer: false,
    tax_regime: false,
    use_cfdi: false,
    zip_code: false,
  };

  regimes$: Observable<Regime[]>;
  cfdis$: Observable<Cfdi[]>;

  constructor(private billingService: BillingService, private modal: ModalController) {
    this.regimes$ = this.billingService.getRegimes();
    this.cfdis$ = this.billingService.getCfdis();
  }

  ngOnInit() {
    if (this.billing) {
      this.form.patchValue(this.billing);
    } else {
      this.form.patchValue({
        taxpayer: 'natural',
      });
    }
  }

  sendData() {
    this.load = true;
    this.errorData = {
      name: false,
      email: false,
      rfc: false,
      taxpayer: false,
      tax_regime: false,
      use_cfdi: false,
      zip_code: false,
    };
    const action = this.billing
      ? this.billingService.editBilling(this.form.value)
      : this.billingService.createBilling(this.form.value);
    action
      .pipe(
        take(1),
        catchError((error: HttpErrorResponse) => {
          this.load = false;
          if (error.error.errors) {
            this.errorData = error.error.errors;
          }
          return null;
        })
      )
      .subscribe((response: ApiResponse<Billing>) => {
        this.load = false;
        if (response) {
          this.modal.dismiss({ billing: response.data });
        }
      });
  }

  back() {
    this.modal.dismiss();
  }
}
